import { RouterProvider } from "react-router-dom"

import { useCommon } from "~/store/common/commonSlice"
import { router } from "./router"

import "./style/style.css"

import Box from "@mui/material/Box"

function App() {
  const { isRtl } = useCommon()
  // useFirebaseMessaging()

  // console.log("update")

  return (
    <Box dir={isRtl ? "rtl" : "ltr"} sx={{ height: "100vh" }}>
      <RouterProvider router={router} />
    </Box>
  )
}

export default App
